// src/pages/Dashboard.js
import React, {useState} from "react";
import "./Dashboard.css";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {Link} from 'react-router-dom';


const Dashboard = () => {
    {/* Sidenav Expansion*/}
        const [openCategory, setOpenCategory] = useState(null);

        const toggleCategory = (category) => {
            setOpenCategory(openCategory === category ? null : category);
        }
    {/* Project List Expansion*/}
        const [expandedProject, setExpandedProject] = useState(null);

        const toggleProject = (project) => {
        setExpandedProject(expandedProject === project ? null : project);
        };

    return (
        <div className="dashboard-container">
            <aside className="sidebar">
                <h2>Career Center</h2>
                <ul>
                    <li style={{color:"goldenrod"}}>COURSE OUTLINE</li>

                    <li onClick={() => toggleCategory('programming')} style={{cursor: 'pointer'}}>
                        <strong> Programming Courses <ArrowDropDownIcon/></strong>
                    </li>
                    {openCategory === 'programming' && (
                        <ul className="submenu">
                            <li><ArrowForwardIcon/> Java</li>
                            <li><ArrowForwardIcon/> Python</li>
                            <li><ArrowForwardIcon/> C++</li>
                            <li><ArrowForwardIcon/> C#</li>
                        </ul>
                    )}

                    <li onClick={() => toggleCategory('webdev')} style={{cursor: 'pointer'}}>
                        <strong> Web Dev Courses <ArrowDropDownIcon/></strong>
                    </li>
                    {openCategory === 'webdev' && (
                        <ul className="submenu">
                            <li><ArrowForwardIcon/> HTML5</li>
                            <li><ArrowForwardIcon/> CSS</li>
                            <li><ArrowForwardIcon/> JavaScript</li>
                            <li><ArrowForwardIcon/> React</li>
                            <li><ArrowForwardIcon/> Angular</li>
                            <li><ArrowForwardIcon/> Express.js</li>
                            <li><ArrowForwardIcon/> Spring Boot</li>
                        </ul>
                    )}

                    <li onClick={() => toggleCategory('sia')} style={{cursor: 'pointer'}}>
                        <strong> SIA Courses <ArrowDropDownIcon/></strong>
                    </li>
                    {openCategory === 'sia' && (
                        <ul className="submenu">
                            <Link to="/door-supervisor-dashboard" target="_blank" rel="noreferrer">
                                <li style={{color: "white", borderBottom: "2px solid white"}}> SIA Door Supervisor</li>
                            </Link>
                            <Link to="/door-supervisor-quiz" target="_blank" rel="noreferrer">
                                <li style={{
                                    color: "goldenrod",
                                    textAlign: "center",
                                    borderBottom: "2px solid white"
                                }}>SIA-Door-Quiz
                                </li>
                            </Link>
                            <Link to="/cctv-operator-dashboard" target="_blank" rel="noreferrer">
                                <li style={{color: "white", borderBottom: "2px solid white"}}> SIA CCTV</li>
                            </Link>
                            <Link to="/security-guard-dashboard" target="_blank" rel="noreferrer">
                                <li style={{color: "white", borderBottom: "2px solid white"}}> SIA Security Guarding
                                </li>
                            </Link>
                            <Link to="/door-supervisor-dashboard" target="_blank" rel="noreferrer">
                                <li style={{color: "white", borderBottom: "2px solid white"}}> SIA Upskill Courses</li>
                            </Link>
                        </ul>
                    )}

                    <li onClick={() => toggleCategory('language')} style={{cursor: 'pointer'}}>
                        <strong> Language Courses <ArrowDropDownIcon/></strong>
                    </li>
                    {openCategory === 'language' && (
                        <ul className="submenu">
                            <Link to="/english-for-professionals " target="_blank" rel="noreferrer">
                                <li style={{color: "white", borderBottom: "2px solid white"}}>English for
                                    Professionals
                                </li>
                            </Link>
                            <Link to="/german-language" target="_blank" rel="noreferrer">
                                <li style={{color: "white", borderBottom: "2px solid white"}}>German Language</li>
                            </Link>
                            <Link to="/finnish-language" target="_blank" rel="noreferrer">
                                <li style={{color: "white", borderBottom: "2px solid white"}}>Finnish Language</li>
                            </Link>
                            <Link to="/chinese-language" target="_blank" rel="noreferrer">
                                <li style={{color: "white", borderBottom: "2px solid white"}}>Chinese Language</li>
                            </Link>
                            <Link to="/nigerian-language" target="_blank" rel="noreferrer">
                                <li style={{color: "white", borderBottom: "2px solid white"}}>Yoruba Language</li>
                            </Link>
                        </ul>
                    )}
                    <li></li>
                    <li></li>
                    <li></li>
                    <li>Quizzes</li>
                    <li>Answers</li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li style={{color:"goldenrod"}}>PROJECT LIST</li>
                    <li>Bookmarking Projects</li>
                    <li>Car Hiring Projects</li>
                    <li>E-commerce Projects</li>
                    <li>AI Chatbot</li>
                </ul>
            </aside>

            <main className="main-content">
            <header>
                    <h1 style={{textAlign:"center", width:"100%", color:"white"}}>Welcome Back, Student!</h1>
                </header>

                <section className="stats">
                    <div className="card"><h3>Course List</h3> <p>15 </p></div>
                    <div className="card"><h3>Active Students</h3> <p>25</p></div>
                    <div className="card"><h3>AI Suggestions</h3> <p>Recommended Learning Path</p></div>
                </section>

                <section className="course-list">
                    <h2>Project List</h2>

                    {/* Bookmarking Web App */}
                    <div className="course">
                        <button onClick={() => toggleProject('bookmark')}><h3>1 Bookmarking  App</h3></button>
                        {expandedProject === 'bookmark' && (
                            <div className="project-detail">
                              <ul>
                                    <li><strong>Frontend:</strong> React with hooks, responsive layout using Tailwind or
                                        Material UI
                                    </li>
                                    <li><strong>Backend:</strong> Express.js with RESTful APIs</li>
                                    <li><strong>Database:</strong> MongoDB with Mongoose</li>
                                    <li><strong>Authentication:</strong> JWT & OAuth integration</li>
                                    <li><strong>Topics Covered:</strong> CRUD, user auth, API security, deployment</li>
                                </ul>
                            </div>
                        )}
                    </div>

                    {/* Car Hiring Web App */}
                    <div className="course">


                        <button onClick={() => toggleProject('carhire')}>  <h3>2 Car Hiring  App</h3></button>
                        {expandedProject === 'carhire' && (
                            <div className="project-detail">
                                <p>This app lets users browse, book, and manage car rental services with admin
                                    dashboards.</p>
                                <ul>
                                    <li><strong>Frontend:</strong> React with Redux Toolkit</li>
                                    <li><strong>Backend:</strong> Spring Boot (Java) with REST API</li>
                                    <li><strong>Database:</strong> MySQL using Spring Data JPA</li>
                                    <li><strong>Topics Covered:</strong> MVC, session auth, relational DB design,
                                        pagination
                                    </li>
                                </ul>
                            </div>
                        )}
                    </div>

                    {/* Product Delivery Web App */}
                    <div className="course">


                        <button onClick={() => toggleProject('delivery')}> <h3>3 Product Delivery  App</h3></button>
                        {expandedProject === 'delivery' && (
                            <div className="project-detail">
                                <p>This logistics app helps manage product deliveries with real-time order tracking and
                                    admin control.</p>
                                <ul>
                                    <li><strong>Frontend:</strong> React + React Router</li>
                                    <li><strong>Backend:</strong> Express.js with Node.js</li>
                                    <li><strong>Database:</strong> PostgreSQL with Sequelize ORM</li>
                                    <li><strong>Topics Covered:</strong> REST APIs, order workflows, role-based access,
                                        charts
                                    </li>
                                </ul>
                            </div>
                        )}
                    </div>

                </section>

            </main>

        </div>

    );
};

export default Dashboard;
